/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Grid2 as Grid,
  TextField,
  MenuItem,
} from "@mui/material";
import IconDelete from "@mui/icons-material/Delete";
import IconView from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, validate } from "validate.js";

import {
  resetStateEvents,
  submitEvent,
  updateEvent,
  uploadEventGallery,
} from "../../app/slices/eventsSlice";
import AppMessage from "../../components/AppMessage/AppMessage";
import moment from "moment";
import {
  generateRandomString,
  getBase64,
  oracleDateFormat,
} from "../../app/utils";

const EventDialog = ({
  open,
  onClose,
  method: defaultMethod,
  readOnly = false,
  selectedEvent,
  title,
}) => {
  const {
    data: dataPost,
    status: statusPost,
    error: errorPost,
  } = useSelector(({ events }) => events.post);
  const {
    data: dataPut,
    status: statusPut,
    error: errorPut,
  } = useSelector(({ events }) => events.put);
  const {
    data: dataGallery,
    status: statusGallery,
    error: errorGallery,
  } = useSelector(({ events }) => events.gallery);

  const schema = {
    title: {
      presence: { allowEmpty: false },
    },
    description: {
      presence: { allowEmpty: false },
    },
    eventDate: {
      presence: { allowEmpty: false },
    },
  };

  const statuses = [
    { value: "A", label: "Active" },
    { value: "I", label: "Inactive" },
  ];

  const [formValues, setFormValues] = useState(selectedEvent || {});
  const [errors, setErrors] = useState([]);
  const [response, setResponse] = useState(null);
  const [showInput, setShowInput] = useState(true);
  const [method, setMethod] = useState(defaultMethod);
  const dispatch = useDispatch();

  //use effect
  useEffect(() => {
    dispatch(resetStateEvents(["post"]));
    dispatch(resetStateEvents(["put"]));
    dispatch(resetStateEvents(["gallery"]));
    return () => {
      dispatch(resetStateEvents(["post"]));
      dispatch(resetStateEvents(["put"]));
      dispatch(resetStateEvents(["gallery"]));
    };
  }, []);

  useEffect(() => {
    if ((errorPost, errorPut, errorGallery)) {
      setResponse({
        type: "error",
        message:
          errorPost?.message || errorPut?.message || errorGallery?.message,
      });
    }
  }, [errorPost, errorPut, errorGallery]);

  useEffect(() => {
    if (dataPost) {
      setResponse({
        type: "success",
        message: "Event posted successfully",
      });

      setFormValues({ ...formValues, eventId: dataPost });
      setShowInput(false);
      setTimeout(() => {
        setShowInput(true);
      }, 400);
      setMethod("UPDATE");
    }
  }, [dataPost]);

  useEffect(() => {
    if (dataPut) {
      setResponse({
        type: "success",
        message: dataPut,
      });

      setShowInput(false);
      setTimeout(() => {
        setShowInput(true);
      }, 400);
    }
  }, [dataPut]);

  useEffect(() => {
    if (dataGallery) {
      setResponse({
        type: "success",
        message: dataGallery,
      });
      let _images = [...(formValues?.images || [])];
      console.log("******** _images", _images);
      if (formValues?._prevFileName) {
        _images.push({ attachment: formValues?._prevFileName });
      }
      setFormValues({
        ...formValues,
        images: _images,
        fileActual: null,
        file: null,
      });
      setShowInput(false);
      setTimeout(() => {
        setShowInput(true);
      }, 400);
    }
  }, [dataGallery]);

  //methods
  const handleSubmit = async () => {
    let _errors = validate(
      formValues,
      method === "UPDATE"
        ? schema
        : {
            ...schema,
            coverImage: {
              presence: { allowEmpty: false },
            },
          }
    );

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(resetStateEvents(["post"]));
    dispatch(resetStateEvents(["put"]));

    if (method === "ADD") {
      let _fileName = `EVT-${moment().format(
        "DDMMYYYY"
      )}-${generateRandomString(4)}.${formValues?.coverImage
        ?.split(".")
        .pop()}`;

      let base64 = await getBase64(formValues?.coverImageFile);

      let _payload = {
        title: formValues?.title,
        description: formValues?.description,
        event_date: moment(formValues?.eventDate).format(oracleDateFormat),
        cover_image: _fileName,
        _meta: [
          { path: "../uploads/events/", fileName: _fileName, file: base64 },
        ],
      };

      dispatch(submitEvent(_payload));
    } else if (method === "UPDATE") {
      //TODO: do cover image update logic
      let _payload = {
        id: formValues?.eventId,
        payload: {
          title: formValues?.title,
          description: formValues?.description,
          event_date: moment(formValues?.eventDate).format(oracleDateFormat),
          status: formValues?.status,
        },
      };

      dispatch(updateEvent(_payload));
    }
  };

  const handleChange = (e) => {
    const inputName = e?.target?.name;
    const inputValue = e?.target?.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  const handleFileChange = async (e) => {
    let inputName = e?.target?.name;
    if (inputName === "coverImage") {
      let coverImageBase64 = await getBase64(e?.target?.files[0]);
      setFormValues({
        ...formValues,
        coverImage: e?.target?.files[0]?.name || "",
        coverImageFile: e?.target?.files[0],
        coverImageBase64: coverImageBase64,
      });
    } else if (inputName === "file") {
      setFormValues({
        ...formValues,
        file: e?.target?.files[0]?.name || "",
        fileActual: e?.target?.files[0],
      });
    }
  };

  const addImage = async () => {
    dispatch(resetStateEvents(["gallery"]));
    if (formValues?.file && formValues?.eventId) {
      let _fileName = `EVT-GLR-${moment().format(
        "DDMMYYYY"
      )}-${generateRandomString(4)}.${formValues?.file?.split(".").pop()}`;

      setFormValues({ ...formValues, _prevFileName: _fileName });

      let base64 = await getBase64(formValues?.fileActual);

      let _payload = {
        event_id: formValues?.eventId,
        attachment: _fileName,
        _meta: [
          { path: "../uploads/events/", fileName: _fileName, file: base64 },
        ],
      };

      dispatch(uploadEventGallery(_payload));
    }
  };

  const removeImage = () => {};

  //builders
  const BuildForm = () => {
    return (
      <Grid container spacing={2}>
        {(formValues.coverImageBase64 || formValues?.cover_image) && (
          <Grid size={12}>
            <div className="flex-row justify-content-center">
              <img
                id="event-cover"
                src={
                  formValues?.coverImageBase64 ||
                  `${process.env.REACT_APP_SERVER_URL}/uploads/events/${formValues?.cover_image}`
                }
                alt=""
              />
            </div>
          </Grid>
        )}
        <Grid size={{ md: 6, xs: 12 }}>
          <TextField
            fullWidth
            required
            disabled={readOnly}
            variant="outlined"
            type="text"
            name="title"
            error={errors["title"] ? true : false}
            helperText={errors["title"] ? errors.title[0] : null}
            id="title"
            label="Event Title"
            onChange={handleChange}
            value={formValues?.title || ""}
          />
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <TextField
            fullWidth
            disabled={readOnly}
            required
            variant="outlined"
            type="date"
            slotProps={{
              inputLabel: { shrink: true },
            }}
            name="eventDate"
            error={errors["eventDate"] ? true : false}
            helperText={errors["eventDate"] ? errors.eventDate[0] : null}
            id="eventDate"
            label="Event Date"
            onChange={handleChange}
            value={formValues?.eventDate || ""}
          />
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <TextField
            fullWidth
            disabled={readOnly}
            required
            variant="outlined"
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { accept: "image/*" },
            }}
            type="file"
            name="coverImage"
            id="coverImage"
            label="coverImage"
            error={errors["coverImage"] ? true : false}
            helperText={errors["coverImage"] ? errors.coverImage[0] : null}
            onChange={handleFileChange}
          />
        </Grid>
        {method !== "ADD" && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              required
              disabled={readOnly}
              fullWidth
              variant="outlined"
              name="status"
              id="incident-rating"
              select
              label="Status"
              error={errors["status"] ? true : false}
              helperText={errors["status"] ? errors.status[0] : null}
              onChange={handleChange}
              value={formValues?.status}
            >
              {statuses.map((option) => {
                return <MenuItem value={option.value}>{option.label}</MenuItem>;
              })}
            </TextField>
          </Grid>
        )}
        <Grid size={12}>
          <TextField
            fullWidth
            required
            disabled={readOnly}
            multiline
            rows={readOnly ? 5 : 3}
            variant="outlined"
            type="text"
            name="description"
            id="description"
            label="Description"
            error={errors["description"] ? true : false}
            helperText={errors["description"] ? errors.description[0] : null}
            onChange={handleChange}
            value={formValues?.description || ""}
          />
        </Grid>

        <Grid size={12}>{BuildImageGallery()}</Grid>
      </Grid>
    );
  };

  const BuildImageGallery = () => {
    return (
      <>
        {formValues?.eventId && (
          <div className="p-20 form-darker-section">
            <Grid size={12} spacing={2} container>
              <Grid size={12}>
                <p>Gallery Images</p>
              </Grid>
              {!readOnly && showInput && (
                <>
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <TextField
                      disabled={readOnly}
                      fullWidth
                      required
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                        htmlInput: { accept: "image/*" },
                      }}
                      type="file"
                      name="file"
                      error={errors["file"] ? true : false}
                      helperText={errors["file"] ? errors.file[0] : null}
                      id="file"
                      label="File"
                      onChange={handleFileChange}
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 4 }}>
                    <Button
                      style={{ marginTop: "5px" }}
                      id="btn-add-attachment"
                      variant="contained"
                      size="small"
                      disabled={
                        statusGallery === "loading" ||
                        isEmpty(formValues?.fileActual)
                      }
                      onClick={addImage}
                      color="secondary"
                    >
                      {statusGallery === "loading"
                        ? "Uploading..."
                        : "+ Add Image"}
                    </Button>
                  </Grid>
                </>
              )}

              <Grid item size={12}>
                {formValues?.images?.length > 0 && (
                  <table className="app-simple-table">
                    <thead>
                      <th>File Name</th>
                      <th>Preview</th>
                      {!readOnly && <th>Remove</th>}
                    </thead>
                    <tbody>
                      {formValues?.images?.map((item, index) => (
                        <tr>
                          <td>{item?.attachment}</td>

                          <td>
                            <div className="icon-button">
                              <IconView
                                color="primary"
                                onClick={() => {
                                  window.open(
                                    `${process.env.REACT_APP_SERVER_URL}/uploads/events/${item.attachment}`
                                  );
                                }}
                              />
                            </div>
                          </td>

                          {!readOnly && (
                            <td>
                              <div className="icon-button">
                                <IconDelete
                                  color="error"
                                  onClick={() => {
                                    removeImage(index);
                                  }}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {(formValues?.images?.length === 0 ||
                  formValues?.images === undefined) && (
                  <div className="flex-row p-20 justify-content-center">
                    No images added
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </>
    );
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        <span id="modal-header">
          <b>{title}</b>
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className="p-10">{BuildForm()}</div>
          {response && (
            <AppMessage
              isOpen={response !== null}
              message={response?.message}
              messageType={response?.type}
              onClose={() => {
                setResponse(null);
              }}
            />
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {dataPost === null && dataPut === null && !readOnly && (
          <Button
            id="btn-confirm"
            variant="contained"
            size="small"
            disabled={statusPost === "loading" || statusPut === "loading"}
            onClick={handleSubmit}
            color="primary"
          >
            {statusPost === "loading" && (
              <CircularProgress
                size={20}
                color="white"
                style={{ marginRight: "5px" }}
              />
            )}
            {method === "ADD" ? "Post" : "Update"}
          </Button>
        )}

        <Button
          id="btn-close"
          variant="contained"
          size="small"
          onClick={() => {
            onClose(dataPost || dataPut || dataGallery ? true : false);
          }}
          color="error"
        >
          <CloseIcon fontSize="small" className="app-button-icon" /> Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EventDialog;
